export const GST_CONSENT_LINK_LABEL = 'GST Consent Link';
export const COPIED_LABEL = 'Copied';
export const GST_CONSENT_LOG_LABEL = 'GST Consent Log';
export const CONSENT_LINK_COPY_ID = 'gstConsentLink';
export const GST_CONSENT_LINK_FAILED_TOAST = 'Failed to generate the GST consent link. Please try again.';
